import { MessageStatus } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/voicemail.pb';
import { createShallowStore, createStore } from '@frontend/store';
import { CallRecordsFiltersType, VoicemailFiltersType } from '../../hooks/use-phone-config-state-store';
import { defaultDateRangeMap } from '../../utils';
import { DEFAULT_NO_TIME_PERIOD } from '../filter-selectors/time-period-selector';

export type CallHistoryView = {
  id: string;
  filters: CallRecordsFiltersType;
  hiddenColumns: string[];
  name: string;
};

export type VoicemailView = {
  id: string;
  filters: VoicemailFiltersType;
  hiddenColumns: string[];
  name: string;
};

/**
 * This was part of the POC for views management.
 * Commenting instead of deleting as we might want to revisit this later.
 */

// export const ViewBar = ({
//   activeView,
//   setActiveView,
//   views: _views = [],
//   addView,
//   editView,
//   removeView,
//   onSelect,
// }: {
//   activeView: string;
//   setActiveView: (view: string) => void;
//   views: CallHistoryView[];
//   addView: (view: CallHistoryView) => void;
//   editView: (view: CallHistoryView) => void;
//   removeView: (view: CallHistoryView) => void;
//   onSelect: (view: CallHistoryView) => void;
// }) => {
//   const { t } = useTranslation();
//   const [showEditor, setShowEditor] = useState(false);
//   const [isEditingBar, setIsEditingBar] = useState(false);
//   const [viewToEdit, setViewToEdit] = useState<CallHistoryView>();

//   const field = useFormField({ type: 'text', value: viewToEdit?.name }, [viewToEdit]);

//   let title = t('Views');

//   if (isEditingBar) {
//     title = t('Organize Views');
//   } else if (showEditor) {
//     title = t('Add View');
//   }

//   return (
//     <div css={{ display: 'grid', gap: theme.spacing(1), width: 400 }}>
//       <div css={{ display: 'grid', gap: theme.spacing(3), gridTemplateColumns: 'auto 1fr' }}>
//         <Heading level={3}>{title}</Heading>
//         {!isEditingBar && !showEditor && (
//           <div
//             css={{
//               display: 'grid',
//               gap: theme.spacing(1),
//               gridTemplateColumns: 'max-content max-content',
//               justifySelf: 'end',
//             }}
//           >
//             <Button
//               variant='secondary'
//               iconName='edit'
//               onClick={() => {
//                 setIsEditingBar(true);
//               }}
//             ></Button>
//             <Button
//               variant='secondary'
//               iconName='add'
//               onClick={() => {
//                 setShowEditor(true);
//               }}
//             ></Button>
//           </div>
//         )}
//       </div>
//       <div css={{ display: 'grid', gap: theme.spacing(1) }}>
//         <div
//           css={{
//             display: 'flex',
//             gap: theme.spacing(1),
//           }}
//         >
//           {_views.length > 0 &&
//             _views.map((view) => {
//               const color = view.id === activeView ? 'blue' : 'gray';

//               if (isEditingBar) {
//                 return (
//                   <Chip.Tag
//                     key={view.id}
//                     color={viewToEdit?.id === view.id ? 'blue' : 'gray'}
//                     onClick={() => {
//                       setViewToEdit(view);
//                     }}
//                     isRemovable
//                     onRemoveClick={() => {
//                       removeView(view);
//                     }}
//                   >
//                     {view.name}
//                   </Chip.Tag>
//                 );
//               }

//               return (
//                 <Chip.Tag
//                   key={view.id}
//                   color={color}
//                   onClick={() => {
//                     setActiveView(view.id);
//                     onSelect(view);
//                   }}
//                   css={{ cursor: 'pointer', maxWidth: 200 }}
//                 >
//                   {view.name}
//                 </Chip.Tag>
//               );
//             })}
//         </div>
//         {isEditingBar && (
//           <>
//             <Divider margin={theme.spacing(1)} />

//             {viewToEdit ? (
//               <div
//                 css={{
//                   display: 'grid',
//                   gap: theme.spacing(1),
//                   gridTemplateColumns: '1fr max-content max-content',
//                 }}
//               >
//                 <TextField css={{ maxWidth: 200 }} {...field} name='view-name' label={'Name'} />
//                 <Button
//                   size='large'
//                   onClick={() => {
//                     setViewToEdit(undefined);
//                   }}
//                   variant='secondary'
//                 >
//                   {t('Cancel')}
//                 </Button>

//                 <Button
//                   size='large'
//                   css={{ width: 'max-content', justifySelf: 'end' }}
//                   variant='secondary'
//                   onClick={() => {
//                     setIsEditingBar(false);
//                     editView({ ...viewToEdit, name: field.value });
//                   }}
//                 >
//                   {t('Done')}
//                 </Button>
//               </div>
//             ) : (
//               <div
//                 css={{
//                   display: 'grid',
//                   gap: theme.spacing(1),
//                 }}
//               >
//                 <Button
//                   size='large'
//                   css={{ width: 'max-content', justifySelf: 'end' }}
//                   variant='secondary'
//                   onClick={() => {
//                     setIsEditingBar(false);
//                   }}
//                 >
//                   {t('Done')}
//                 </Button>
//               </div>
//             )}
//           </>
//         )}
//         <AnimatePresence>
//           {showEditor && <ViewEditor setIsEditing={setShowEditor} addView={addView} setActiveView={setActiveView} />}
//         </AnimatePresence>
//       </div>
//     </div>
//   );
// };

// const ViewEditor = ({
//   setIsEditing,
//   addView,
//   setActiveView,
// }: {
//   setIsEditing: (isEditing: boolean) => void;
//   addView: (views: CallHistoryView) => void;
//   setActiveView: (view: string) => void;
// }) => {
//   const { t } = useTranslation();
//   const viewNameField = useFormField({ type: 'text' });
//   const draft = useCustomViewStore((state) => state.draft);

//   return (
//     <>
//       <Divider margin={theme.spacing(1)} />
//       <motion.div
//         css={{
//           display: 'grid',
//           gap: theme.spacing(1),
//           gridTemplateColumns: '1fr max-content max-content',
//         }}
//         // variants={{
//         //   open: {
//         //     height: 'auto',
//         //     opacity: 1,
//         //     transition: {
//         //       ease: 'easeInOut',
//         //       opacity: { duration: 0.3 },
//         //       height: { duration: 0.1 },
//         //     },
//         //   },
//         //   closed: {
//         //     height: 0,
//         //     opacity: 0,
//         //     transition: {
//         //       ease: 'easeInOut',
//         //       opacity: { duration: 0.15 },
//         //       height: { duration: 0.01 },
//         //     },
//         //   },
//         // }}
//         // animate='open'
//         // initial='closed'
//         // exit='closed'
//       >
//         <TextField css={{ maxWidth: 200 }} {...viewNameField} name='view-name' label={'Name'} />
//         <Button
//           size='large'
//           onClick={() => {
//             setIsEditing(false);
//           }}
//           variant='secondary'
//         >
//           {t('Cancel')}
//         </Button>
//         <Button
//           size='large'
//           onClick={() => {
//             const id = Date.now().toString();
//             addView({ ...draft, id, name: viewNameField.value });
//             setIsEditing(false);
//             setActiveView(id);
//             viewNameField.onChange({ name: 'view-name', value: '' });
//           }}
//         >
//           {t('Done')}
//         </Button>
//       </motion.div>
//     </>
//   );
// };

export const useCallHistoryViewStore = createStore<{
  draft: CallHistoryView;
  setDraft: (draft: Partial<CallHistoryView>) => void;
}>(
  (set) => ({
    draft: {
      id: 'call-history',
      name: 'Call History',
      filters: {
        status: [],
        phoneNumber: '',
        name: '',
        locationIds: [],
        startDate: defaultDateRangeMap[DEFAULT_NO_TIME_PERIOD].startDate,
        endDate: defaultDateRangeMap[DEFAULT_NO_TIME_PERIOD].endDate,
        officePhoneNumbers: [],
        callDirection: undefined,
      },
      hiddenColumns: [],
    },
    setDraft: (draft) => set((state) => ({ draft: { ...state.draft, ...draft } })),
  }),
  {
    name: 'CallHistoryViewStore',
  },
  /**
   * Signing out will cause a global reset of all stores - which will trigger subscriptions to run.
   * We want to opt out of that here to avoid overwriting saved views with the default draft.
   */
  {
    optOutGlobalReset: true,
  }
);

export const useVoicemailViewStore = createStore<{
  draft: VoicemailView;
  setDraft: (draft: Partial<VoicemailView>) => void;
}>(
  (set) => ({
    draft: {
      id: 'voicemail',
      name: 'Voicemail',
      filters: {
        filterOptions: {
          callerNumber: '',
          callerName: '',
          endTime: '',
          startTime: '',
          status: MessageStatus.MESSAGE_STATUS_ALL,
          mailboxIds: [],
          tagIds: [],
        },
        locationIds: [],
        syncDeviceSipProfileIds: [],
      },
      hiddenColumns: [],
    },
    setDraft: (draft) => set((state) => ({ draft: { ...state.draft, ...draft } })),
  }),
  {
    name: 'VoicemailViewStore',
  },
  /**
   * Signing out will cause a global reset of all stores - which will trigger subscriptions to run.
   * We want to opt out of that here to avoid overwriting saved views with the default draft.
   */
  {
    optOutGlobalReset: true,
  }
);

export const useCallHistoryViewShallowStore = createShallowStore(useCallHistoryViewStore);
export const useVoicemailViewShallowStore = createShallowStore(useVoicemailViewStore);
